import React from "react";
import { WHATSAPP_LINK, openWhatsApp } from "@/data/site";
import { WhatsappLogo } from "@phosphor-icons/react";

export function WhatsAppButton() {
  return (
    <a
      href={WHATSAPP_LINK}
      onClick={openWhatsApp}
      target="_blank"
      rel="noopener noreferrer"
      data-testid="whatsapp-float-button"
      aria-label="Chat on WhatsApp"
      className="fixed bottom-6 left-6 z-50 flex items-center gap-2 rounded-full bg-[#25D366] px-4 py-3 text-white shadow-lg shadow-black/20 transition-transform duration-300 hover:-translate-y-1"
    >
      <WhatsappLogo size={26} weight="fill" />
      <span className="hidden sm:inline text-sm font-semibold">WhatsApp</span>
    </a>
  );
}
